// lib/execDrillLink.mjs — R115 fix: the sessionStorage writes the Executive
// Summary drill (client/src/shared/components/ExecDrill.ts go()) makes before
// it navigates to a row's destination. Plain ESM so
// `node lib/execDrillLink.test.mjs` tests the exact code the sheet runs (the
// arrivalsDayView pattern); types live in execDrillLink.d.mts.
//
// Every key the link carries is written as-is (empty / null skipped) EXCEPT an
// Arrivals Day link (keys.rt_view === 'day'), which goes through the Day
// view's own hand-off (lib/arrivalsDayView arrivalsHandoff — the Calendar's
// "Open Arrivals" rule) so the stay is actually on screen when it opens:
//   • a stored Check-outs tab (rt_day_mode 'out' — it hides every arrival)
//     becomes Check-ins;
//   • the day is pinned only inside the Day view's window, PAST days included
//     (keepPast — "arrived <date>" payment flags open on that day); today,
//     unknown or out-of-window days remove any stale pinned rt_day, so the
//     page follows today instead of a day left over from an earlier visit;
//   • rt_focus (the checklist to open expanded) rides through.
import { STORE_KEYS, arrivalsHandoff } from './arrivalsDayView.mjs';

export function drillLinkWrites(link, today, curMode) {
  const set = {};
  const remove = [];
  if (!link || !link.page) return { set, remove };
  const keys = (link.keys && typeof link.keys === 'object') ? link.keys : {};
  const dayLink = keys[STORE_KEYS.view] === 'day';
  const handed = new Set([STORE_KEYS.view, STORE_KEYS.day, STORE_KEYS.mode, STORE_KEYS.focus]);
  for (const [k, v] of Object.entries(keys)) {
    if (v == null || v === '') continue;
    if (dayLink && handed.has(k)) continue;   // the hand-off decides these
    set[k] = String(v);
  }
  if (dayLink) {
    const day = keys[STORE_KEYS.day] == null ? null : String(keys[STORE_KEYS.day]);
    const focus = keys[STORE_KEYS.focus] == null || keys[STORE_KEYS.focus] === '' ? null : String(keys[STORE_KEYS.focus]);
    const h = arrivalsHandoff(day, String(today || ''), curMode == null ? null : String(curMode), focus, { keepPast: true });
    Object.assign(set, h.set);
    remove.push(...h.remove);
  }
  return { set, remove };
}
